import $ from "jquery";

import ServiceListComponent from "./service-list.component";

/*
 * Finds and initializes all service-list components
 */

if ($(".service-list-component").length) {
    const serviceListComponents = [];

    $(".service-list-component").each(function () {
        const GUID = $(this).attr("id").replace("service-list-component-", "");
        serviceListComponents.push(new ServiceListComponent($(this), GUID));
    });
}
